import { getCookieObject, setCookie } from '../../storage/cookie';

const PRIVACY_COOKIE_NAME = 'KmxPrivacy';
const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;

export const hasAcceptedPrivacy = (): boolean => {
    const privacyCookie = getCookieObject(PRIVACY_COOKIE_NAME);
    if (!privacyCookie || !privacyCookie.accepted) {
        return false;
    }
    const acceptedTimestamp = parseInt(privacyCookie.accepted, 10);
    if (isNaN(acceptedTimestamp)) {
        return false;
    }
    const currentTime = Date.now();
    const timeDifference = currentTime - acceptedTimestamp;
    return timeDifference < THIRTY_DAYS_IN_MS;
};

export const setPrivacyAccepted = (): void => {
    const timestamp = Date.now().toString();
    setCookie(PRIVACY_COOKIE_NAME, `accepted=${timestamp}`, {
        domain: '.carmax.com',
        expires: 30,
        path: '/'
    });
};
